import FileSaver from 'file-saver';
import { defineConfig } from '../config'
import { authHeader } from '../helpers';
import { utilsService } from './utils'
const { handleResponse, handleResponseBlob } = utilsService

export const systemsService = {
  getApiPath,
  getAllMediaOwners,
  getAllAreaSystems,
  getAllMunicipalities,
  createSystem,
  createSystemV3,
  updateSystemV3,
  getSystemById,
  getFramesBySystemId,
  createFrames,
  createFrameV3,
  deleteFrameV3,
  updateFrameV3,
  updateFrames,
  updateSystem,
  deleteSystem,
  getAllSystemTypes,
  getAllSystemTypesByChannel,
  uploadImage,
  deleteImage,
  getSystemSuggestions,
  getImage,
  getImageBySystemId,
  getMunicipalityById,
  getSystemTypeDimensions,
  createSystemTypeDimensions,
  getSystemSuggestionsNoPagination,
  getDevicesBySystemId,
  createDevices,
  updateDevices,
  createAsset,
  updateAsset,
  deleteAsset,
  createDevice,
  updateDevice,
  deleteDevice,
  createSupplier,
  updateSupplier,
  deleteSupplier,
  getSupplierById,
  getAllSuppliersPaged,
  getAllSuppliersByType,
  getAllSuppliers,
  getSupplierTypes,
  uploadDocument,
  getDocument,
  deleteDocument,
};

const { apiUrl, apiVer } = defineConfig.SYSTEMS_SERVICE;
const systemTypesByChannelCache = new Map();

function getApiPath() {
  return (apiUrl + apiVer + "/system")
}

function getTeamApiPath() {
  return (apiUrl + apiVer + "/system/team")
}

function getTeamManagementApiPath() {
  return (apiUrl + apiVer + "/system/team/management")
}

function getImageApiPath() {
  return (apiUrl + apiVer + "/system/image")
}

function getMediaOwnerApiPath() {
  return (apiUrl + "v3/mediaOwner")
}

function getFrameApiPath() {
  return (apiUrl + apiVer + "/system/frame")
}

function getDeviceApiPath() {
  return apiUrl + apiVer + "/system/device";
}

function getTypeApiPath() {
  return (apiUrl + apiVer + "/system/type")
}

function getSupplierApiPath() {
  return (apiUrl + "v3/system/supplier")
}

function createSupplier(body) {
  const url = getSupplierApiPath() + "/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateSupplier(body, id) {
  const url = getSupplierApiPath() + "/update/" + id;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteSupplier(id) {
  const url = getSupplierApiPath() + "/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSupplierById(id) {
  const url = getSupplierApiPath() + "/read/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSuppliersPaged(page, perPage, filters = {}, sortBy = 'companyName', sortOrder = 'ASC') {
  let url = getSupplierApiPath() + `/all/${page}/${perPage}/${sortBy}/${sortOrder}`;

  const queryParams = new URLSearchParams();

  const { companyName, address, vat, mail, type, phoneNumber } = filters;

  if (companyName) queryParams.append('companyName', companyName);
  if (address) queryParams.append('address', address);
  if (vat) queryParams.append('vat', vat);
  if (mail) queryParams.append('mail', mail);
  if (phoneNumber) queryParams.append('phoneNumber', phoneNumber);

  if (type && type.length > 0) {
    queryParams.append('supplierType', Array.isArray(type) ? type.join(',') : type);
  }

  const queryString = queryParams.toString();
  if (queryString) {
    url += `?${queryString}`;
  }

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSuppliersByType(type) {
  const url = getSupplierApiPath() + "/all/" + type;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSuppliers() {
  const url = getSupplierApiPath() + "/all";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSupplierTypes() {
  const url = getSupplierApiPath() + "/all/type";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function uploadImage(file) {
  const url = apiUrl + "v3/system/image/create";
  const formData = new FormData();

  formData.append('file', file);

  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
};

function getDocumentApiPath() {
  return apiUrl + "v3/system/document";
}

// Carica un documento (multipart): restituisce i metadati del documento salvato, tra cui l'id
function uploadDocument(file) {
  const url = getDocumentApiPath() + "/create";
  const formData = new FormData();

  formData.append('file', file);

  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

// Scarica il contenuto di un documento: il nome è già noto, arriva con l'id nella GET dell'impianto
function getDocument(id) {
  const url = getDocumentApiPath() + "/read/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(await response.text() || "Documento non disponibile");
      }

      return response.blob();
    });
}

function deleteDocument(id) {
  const url = getDocumentApiPath() + "/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getImage(id) {
  const url = apiUrl + "v3/system/image/read/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };
  return fetch(
    url,
    requestOptions
  )
    .then(handleResponseBlob)
    .then(blob => {
      if (!(blob instanceof Blob)) {
        return null;
      }

      return URL.createObjectURL(blob);
    })
    .then(res => {
      return res;
    });
}

function getImageBySystemId(systemId) {
  const url = getImageApiPath() + "/read/system/" + systemId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };
  return fetch(
    url,
    requestOptions
  )
    .then(handleResponseBlob)
    .then(blob => {
      if (!(blob instanceof Blob)) {
        return null;
      }

      return URL.createObjectURL(blob);
    })
    .then(res => {
      return res;
    });
}

function deleteImage(id) {
  const url = apiUrl + "v3/system/image/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
};

function getAllSystemTeamsPaged(page, perPage, companyName = '', address = '', vat = '', mail = '', type = [], phone = '', sortOrder = 'ASC') {
  const url = getTeamApiPath() + "/all/" + page + "/" + perPage;

  const body = {
    companyName: companyName,
    address: address,
    vat: vat,
    SystemTeamManagementType: type,
    mail: mail,
    phone: phone,
    sortOrder: sortOrder
  }

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemTeams() {
  const url = getTeamApiPath() + "/all";
  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTeamById(id) {
  const url = getTeamApiPath() + "/read/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateSystemTeam(body, id) {
  const url = getTeamApiPath() + "/update/" + id;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createSystemTeam(body) {
  const url = getTeamApiPath() + "/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteSystemTeam(id) {
  const url = getTeamApiPath() + "/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTeamDuties() {
  const url = getTeamApiPath() + "/all/duty";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createSystemTeamManagement(body) {
  const url = getTeamManagementApiPath() + "/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateSystemTeamManagement(body) {
  const url = getTeamManagementApiPath() + "/update";

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTeamManagementsBySystem(systemId) {
  const url = getTeamManagementApiPath() + "/all/" + systemId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteSystemTeamManagement(systemTeamManagementId) {
  const url = getTeamManagementApiPath() + "/delete/" + systemTeamManagementId;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllMediaOwners() {
  const url = getMediaOwnerApiPath() + "/all";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getFramesBySystemId(systemId) {
  const url = getFrameApiPath() + "/all/" + systemId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createFrames(frameData, systemId) {
  const url = getFrameApiPath() + "/create/all/" + systemId

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(frameData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function createFrameV3(frameData) {
  const url = apiUrl + "v3/system/frame/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(frameData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function deleteFrameV3(frameId) {
  const url = apiUrl + "v3/system/frame/delete/" + frameId;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function updateFrameV3(frameId, frameData) {
  const url = apiUrl + "v3/system/frame/update/" + frameId;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(frameData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function updateFrames(frameData, systemId) {
  const url = getFrameApiPath() + "/update/" + systemId

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(frameData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function getDevicesBySystemId(systemId) {
  const url = getDeviceApiPath() + "/all/" + systemId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function createDevices(deviceData, systemId) {
  const url = getDeviceApiPath() + "/create/all/" + systemId;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(deviceData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function updateDevices(deviceData, systemId) {
  const url = getDeviceApiPath() + "/update/" + systemId;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(deviceData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function createAsset(assetData) {
  const url = apiUrl + "v3/system/asset/create";
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(assetData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function updateAsset(id, assetData) {
  const url = apiUrl + "v3/system/asset/update/" + id;
  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(assetData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function deleteAsset(id) {
  const url = apiUrl + "v3/system/asset/delete/" + id;
  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function createDevice(deviceData) {
  const url = apiUrl + "v3/system/device/create";
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(deviceData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function updateDevice(id, deviceData) {
  const url = apiUrl + "v3/system/device/update/" + id;
  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(deviceData),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}

function deleteDevice(id) {
  const url = apiUrl + "v3/system/device/delete/" + id;
  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}



function getAllMunicipalities() {
  const url = getApiPath() + "/all/municipality";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllAreaSystems() {
  const url = apiUrl + "v3/system/area/all";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemById(id) {
  const url = apiUrl + "v3/system/read/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateSystem(system) {
  const url = getApiPath() + "/update/" + system.id + "/" + system.type;
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(system)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createSystem(system) {
  const { type } = system;
  const url = getApiPath() + "/create/" + type;
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(system)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

//TODO: aggiorna il nome quando tutto il gateway sarà alla V3
function updateSystemV3(systemId, system) {
  const url = apiUrl + "v3/system/update/" + systemId;
  const payload = { ...system };
  delete payload.id;
  delete payload._id;
  delete payload.createdAt;
  delete payload.updatedAt;
  //delete payload.coverImage;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(payload)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

//TODO: aggiorna il nome quando tutto il gateway sarà alla V3
function createSystemV3(system) {
  const url = apiUrl + "v3/system/create";
  const payload = { ...system };
  delete payload.id;
  delete payload._id;
  delete payload.createdAt;
  delete payload.updatedAt;
  delete payload.coverImage;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(payload)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteSystem(systemId) {
  const url = apiUrl + "v3/system/delete/" + systemId;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemTypes() {
  return getAllSystemTypesByChannel("ALL");
}

function getAllSystemTypesByChannel(channel = "ALL") {
  const normalizedChannel = channel || "ALL";
  if (systemTypesByChannelCache.has(normalizedChannel)) {
    return systemTypesByChannelCache.get(normalizedChannel);
  }

  const url = apiUrl + "v3/system/type/all/" + normalizedChannel;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  const request = fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    })
    .catch((error) => {
      systemTypesByChannelCache.delete(normalizedChannel);
      throw error;
    });

  systemTypesByChannelCache.set(normalizedChannel, request);
  return request;
}

function getMunicipalityById(id) {
  const url = getApiPath() + "/read/municipality/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemSuggestions(searchTerm, searchField, page = 0, size = 20, sortBy = "creationDate", sortDir = "descend", type = "ALL", filters = {}) {
  const url = getApiPath() + `/all/suggestion?searchTerm=${encodeURIComponent(searchTerm)}&searchField=${searchField}&page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}&type=${type}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(filters)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemSuggestionsNoPagination(searchTerm, searchField, sortBy = "creationDate", sortDir = "descend", type = "ALL", filters = {}) {
  const url = getApiPath() + `/all/suggestion/map?searchTerm=${encodeURIComponent(searchTerm)}&searchField=${searchField}&sortBy=${sortBy}&sortDir=${sortDir}&type=${type}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(filters)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTypeDimensions(typeId) {
  const url = apiUrl + "v3/system/type/all/dimension/" + typeId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createSystemTypeDimensions(dimension) {
  const url = getTypeApiPath() + "/create/dimension";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(dimension)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}